import { useEffect, useState } from 'react'

/** Matches Tailwind `md` breakpoint by default — viewports below 768px. */
export function useMobileViewport(maxWidthPx = 767) {
  const query = `(max-width: ${maxWidthPx}px)`
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  )

  useEffect(() => {
    const mediaQuery = window.matchMedia(query)
    const onChange = (event: MediaQueryListEvent) => setIsMobile(event.matches)
    mediaQuery.addEventListener('change', onChange)
    setIsMobile(mediaQuery.matches)
    return () => mediaQuery.removeEventListener('change', onChange)
  }, [query])

  return isMobile
}
